<template>
<div>
<div class="mpart1">
  <div class="mpart1-1">
    <div class="mpart1-1Title">

        <img class="decorative-image-main"  width="88" height="88" src="../assets/img/Bus/_ico.svg" alt="">
        <h1 class="mpart1Title">Автобусные остановки</h1>
    </div>
    <p class="mpart1p">Компания «METALIX» предлагает изготовление и монтаж остановочных павильонов из металла, поликарбоната, нержавеющей стали, каленого стекла.</p>
  </div>    
</div>
<div class="mpart2">
    <div class="mpart2-0">
        <div class="mpart5left">Производство</div>
        <div class="mpart5leftLine"></div>
    </div>
    <div class="mpart2-1">
        <!-- <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt=""> -->
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"><b>Автобусные остановки - один из важнейших элементов инфраструктуры в больших и малых городах.</b></p>

<p class="mpart2-1p bus_text">Мы изготовляем удобные и практичные остановки общественного транспорта, опира­ясь на нужды потребителей и заказчиков и значительный опыт в сфере производства металло­конструкций.  </p>   
    </div>
    <div class="mpart2-2" style="position: relative; left: 0; top: 0;">
       
        <img src="../assets/img/Bus/_ico1.svg" class="fish"/>
        <img  class="metal-pic decorative-image-2" src="../assets/img/Bus/image211.png" alt="">
    </div>
    <div class="mpart2-3" style="position: relative; left: 0; top: 0;">
       
        <img src="../assets/img/Bus/_ico1.svg" class="fish"/>
        <img  class="metal-pic decorative-image-2" src="../assets/img/Bus/image206.png" alt="">
    </div>
    <div class="mpart2-4">
        <!-- <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt=""> -->
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p decorative-section-text"> «METALIX» представляет вашему вниманию остановки различной формы и конструкции, с широким выбором цвета и материалов. </p>
<p class="mpart2-1p decorative-section-text bus_text-1"> Кроме того, можно купить оригинальную автобусную остановку, собранную по индивидуально­му проекту. </p>   

    </div>
     <div class="mpart2-5">
        <!-- <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt=""> -->
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p decorative-section-text"><b> Собственный производственный цех </b>– оснащён всем необходимым оборудовани­ем для резки металла, зачистки, сварки, шлифовки, покраски и антикоррозийной обработки. При необходимости бригада опытных рабочих выполняет установку сооружений под ключ непо­средственно на объекте.  </p>   
    </div>
    <div class="mpart2-6" style="position: relative; left: 0; top: 0;">
       
        <img src="../assets/img/Bus/_ico1.svg" class="fish"/>
        <img  class="metal-pic decorative-image-2" src="../assets/img/Bus/image213.png" alt="">
    </div>
   
    
</div>
<div class="part14">
  <div class="part14-8">
    <div class="part14Line"></div>
  </div>
  <div class="part14-0">
        <div class="mpart5left">Преимущества</div>
        <div class="mpart5leftLine"></div>
  </div>
  <div class="part14-1">
    <img src="../assets/img/Bus/ico1.png" width="104px" height="96px" alt="">
    <div class="bus-text" style="margin-left:48px">
      <h1 class="part14h1">Высокая степень надежности</h1>
      <p class="part14p">Жёсткость несущего каркаса, большой запас прочности, устойчи­вость к деформациям и обруше­ниям даже при ураганном ветре.</p>
    </div>
  </div>
  <div class="part14-2">
      <img src="../assets/img/Bus/part14-2.png" width="104px" height="96px" alt="">
    <div class="bus-text" style="margin-left:48px">
      <h1 class="part14h1">Легкость</h1>
      <p class="part14p">Удобство транспортировки. Для изготовления остановочных павильонов применяются сравнительно лёгкие материалы.</p>
    </div>
  </div>
  <div class="part14-3">
     <img src="../assets/img/Bus/ico4.png" width="104px" height="96px" alt="">
    <div class="bus-text" style="margin-left:48px">
      <h1 class="part14h1">Влагостойкость, долговечность</h1>
      <p class="part14p">Герметичная крыша. Находящиеся в остановочном павильоне люди надёжно защищены от снега и дождя. Этому способствует также обшивка боковых стенок из стекла триплекс или проф настила.</p>
    </div>
  </div>
  <div class="part14-4">
    <img src="../assets/img/Bus/ico5.png" width="104px" height="96px" alt="">
    <div class="bus-text" style="margin-left:48px">
      <h1 class="part14h1">Антикорозийность</h1>
      <p class="part14p">
        Антикорозийность. Антикоррозионная стойкость благодаря использованию нержавеющей стали, алюминия и порошковой покраске металлических элементов.
      </p>
    </div>
  </div>
  <div class="part14-5">
    <img src="../assets/img/Bus/ico6.png" width="104px" height="96px" alt="">
    <div class="bus-text" style="margin-left:48px">
      <h1 class="part14h1">Комфорт </h1>
      <p class="part14p">
        Удобные скамейки из профилирован-ной трубы или сухой строганой доски ХВОЙНЫХ пород.      </p>
    </div>
  </div>
  <div class="part14-6">
    <img src="../assets/img/metacons/part14-6.png" width="104px" height="96px" alt="">
    <div class="bus-text" style="margin-left:48px">
      <h1 class="part14h1">Скорость монтажа</h1>
      <p class="part14p">
       Простой, быстрый и сравнительно недорогой монтаж (при необходимости его готовы выполнить наши специалисты).
      </p>
    </div>
  </div>
  
  
</div>
<div class="part15">
  <div class="part15-0">
    <div class="part15Line"></div>
  </div>
  <div class="part15-1">
    <h1 class="part15h1">
    Мы всегда поддерживаем на складе достаточное количество строительных и отделочных материалов. 
  </h1>
  </div>
</div>
<div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="mpart8Line"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h1 class="mpart8Title">
            Эффективные технологии и опыт специалистов позволяет 
            «METALIX» длостигать безупречного результата в сроки.
          </h1>
        </div>
      </div>
      <div class="row" style="padding: 0px">
        <div class="mpart8HideInfo col-md-1 col-sm-12">
          <div class="mpartInfoT">Проекты</div>
           <div class="mpart5leftLine-1"></div>
        </div>
        <div class="col-md-11 col-sm-12">
         <swiper class="swiper ml-3" :options="swiperOptions">
            <swiper-slide>
              <div class="coverImgCarousel8">
                <!-- <img src="../assets/img/Home/image 288.png" /> -->
                <div class="carouselMain" style="">
                    <img style=" margin-right:5rem; color:white; z-index:24;"
                         class="home-icon"
                          src="@/assets/img/Fences/_ico1.svg"
                          alt="section_2_bg_overlay"
                          
                        />
                        <div style=" z-index:33;width:80%"> 
                  <p class="part8mainTitle">
                 Строительство торгового центра.<br> Использование металлоконструкций в <br> каркасных технологиях.
                </p>
                <p class="part8mainTitlep">
                  Складское каркасно-тентовое здание двухскатного<br/> типа р-ром 28х66м. Строительство склада “под<br/> ключ”
                </p>
                        </div>
                </div>
                
                
              </div></swiper-slide
            >
            
            <!-- <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
          </swiper>
          <div class="whiteBox">
            <div id="sppage"></div>
          </div>
        </div>
      </div>
    </div>
  

    <div class="mpart12" >
    
       <div class="mpart12-0Line"></div>
      <!-- </div> -->
      <div class="mpart12-1">
        <div class="mpart12-1Line"></div>
      </div>
      <div class="mpart12-2">
        <h4 class="mpart12-2Info">Обратная связь</h4>
        <div class="mpart12-2InfoLine"></div>
      </div>
     <div class="mpart12-3">
        <h1 class="mpart12-3T">
          Заполните форму обратной <br />
          связи и мы оперативно<br />
          свяжемся с вами !
        </h1>
      </div>
      <div class="mpart12-4">
        <b-form @submit="onSubmit" v-if="show" class="row" action="../../public/test.php"  method="POST">
      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="name"
          id="input-1"
          v-model="name"
          type="name"
          placeholder="Ваша имя"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="surname"
          id="input-2"
          v-model="surname"
          type="surname"
          placeholder="Ваша фамилия"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="email"
          id="input-3"
          v-model="email"
          type="email"
          placeholder="Ваша почта"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="phone"
          id="input-4"
          v-model="phone"
          type="phone"
          placeholder="Ваш номер"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group  class="form-metalix">
        <b-form-input class="form-metalix-1" label="message"
          id="input-5"
          v-model="message"
          type="message"
          placeholder="Комментария"
          
        ></b-form-input>
      </b-form-group>
        <div style="display: flex; width:50%;">
          <input type="checkbox" checked  style="width:30px; height:50px; margin-right:3rem;">
          <p style="color:white;"> Я согласен на обработку<br/>персональных данных.  </p>
         
        </div>

      <b-button data-submit="...Sending" @click="showAlert" class="col-md-6 form-metalix-1 sending-btn" type="submit"  variant="primary">Отправить заявку</b-button>
    </b-form>
      </div>
      <div class="mpart12-5">
        <div class="mpart12TitleLine"></div>
        <p class="mpart12Tp">
          В разделе “комментарий” вы можете указать удобное для вас время когда
          мы можем с вами связаться.
        </p>
      </div>
      <div class="mpart12-6">
        <p class="mpart12Tp2">
          Мы не занимаемся рассылкой рекламных сообщений, а также не передаем
          контактные данные третьим лицам !
        </p>
      </div>
    </div>

    <div class="mpart13">
      <div class="mpart13-0">
        <h4 class="mpart13-0T">Контакты</h4>
        <div class="mpart13-0L"></div>
      </div>
      <div class="mpart13-1">
        <div class="mpart13-1Line"></div>
      </div>
      <div class="mpart13-2">
        <div class="row">
        <div class="col-12">
          <div class="mpart8Line" style="margin-left:0;"></div>
        </div>
      </div>
        <h1 class="mpart13T">
          Мы благодарны Вам за проявленный <br />интерес к нашей компании.
        </h1>
      </div>
      <div class="mpart13-3">
        <p class="mpart13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="mpart13-4">
        <div class="mpart13-4Line"></div>
        <div style="display: flex; margin-top: 84px">
          <img src="../assets/img/location.svg" alt="" />
          <ul class="mpart13-4Address">
            <li>г.Ташкент, Сергели</li>
            <li>ул.Нилуфар 77/7, 100155</li>
          </ul>
        </div>
        <div style="display: flex">
          <img src="../assets/img/phone.svg" alt="" />
          <ul class="mpart13-4PhoneUl">
             <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
          </ul>
        </div>
        <div class="bus_footer" style="display: flex; margin-top: 40px">
          <img src="../assets/img/mail.svg" alt="" />
          <p class="mpart13-4mailp">info@metalix.uz</p>
        </div>
        <div>
          <ul class="mpart13-4PhoneUl2">
            <li>По вопросам партнерства</li>
            <li>+998  90 334 35 00</li>
            <li>info@metalix.uz</li>
          </ul>
        </div>
        <!-- <div style="display: flex">
          <img class="mpart13icon" src="../assets/img/tgb.svg" alt="" />
          <p class="mpart13-4mailp2">Telegram</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/fbb.svg" alt="" />
          <p class="mpart13-4mailp2">Facebook</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/Inb.svg" alt="" />
          <p class="mpart13-4mailp2">Instagram</p>
        </div> -->
      </div>
      <div class="mpart13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
              <iframe 
            class="gmap_iframe"
             
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.6581975340723!2d69.25022158783936!3d41.20638627079112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x702a9595707bb6f!2zNDHCsDEyJzIyLjkiTiA2OcKwMTUnMDguNyJF!5e0!3m2!1sru!2s!4v1636694271660!5m2!1sru!2s" width="100%" height="886" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
        </div>
      </div>
    </div>
   
</div>
</template>
<script>
import Swal from "sweetalert2";
import { directive } from "vue-awesome-swiper";
import axios from 'axios';
import "swiper/swiper-bundle.css";
export default {
  data() {
      return {
        form: {
          name: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
        },
        // foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        show: true,
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        let data = new FormData(); 
    
 
    data.append('name', this.name) 
    data.append('surname', this.surname) 
    data.append('email', this.email) 
    data.append('phone', this.phone) 
    data.append('message', this.message)
    console.log(data)
        axios.post('../../public/test.php', data)

    .then((data) => {Swal('Отправлено');console.log(data)})
    .catch(error => {

       
        console.error('There was an error!', error);
        this.$swal('Error');
    });
      },
      


      showAlert(){
			
  
 
  
			
		},
    },
   components: {
    // VueSlickCarousel,
    // Carousel, Slide
   
  },
  directives: {
    swiper: directive,
  }, 
      mounted () {
  window.scrollTo(0, 0)
}


}
</script>
<style scoped>
/* slider */
.coverImgCarousel8 {
  position: relative;
  /* display: inline-block; */
  width: 100%;
  height: 776px;
  background-image: url("../assets/img/Bus/2.png") !important;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.coverImgCarousel8::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: -moz-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* FF3.6+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Opera 11.10+ */
  background: -ms-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* IE10+ */
  background: radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* W3C */
  /* filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#002f4b', endColorstr='#00000000',GradientType=0 );  */
  /* rgba(35, 59, 87, 0) 0%,
    #233b57 100% */
  /* ); */
  mix-blend-mode: normal;
  opacity: 0.48;
}
.form-metalix {
  margin-bottom: 5rem;
}
.form-metalix-1{
  height: 80px;
}
.sending-btn{
  width: 400px;
  margin-left: 15px !important;
  background-color: white;
  border: none;
  font-family: Styrene A LC;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #272a2e;
}
.part8mainTitle {
  text-align: left;
  /* position: fixed; */
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 64px;
  /* or 137% */
  z-index: 33;
  max-width: 80%;
  letter-spacing: 0.015em;
  text-shadow:  0px 1px 1px black;
  /* _Text */

  color: #fbfbfb;
}
.carouselMain{
position:absolute; 
display:flex;
width: 100%;
height: 100%;
 justify-content:space-evenly;
 align-items: flex-start;
 padding: 15vh 5vw;
}
.mpart1Title{
height: 88px;
font-family: Inter;
font-style: normal;
font-weight: bold;
font-size: 64px;
line-height: 88px;
/* identical to box height, or 137% */
margin-left: 64px;
letter-spacing: 0.015em;
text-transform: uppercase;

/* metalix (ligtt,text) */

color: #36454F;
}
.part8mainTitlep {
  position: absolute;
  width: 696px;
  height: 112px;

  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 40px;
  /* or 167% */
  z-index: 51;
  letter-spacing: 0.1em;

  /* text-shadow: 0px 1px 2px #000; */
  color: #fbfbfb;
}
/* slider */
.swiper-button-prev, .swiper-button-next{
  color: white !important;
}
.inputMar {
 margin-left:152px;
  /* margin-right: 36px; */
}
.miniImgClass{
  width: 104px;
  height: 96px;
  margin-right: 48px;
}
.gmap_canvas {
  overflow: hidden;
  background: none !important;
  width: 100%;
  height: 886px;
}
.gmap_iframe {
  height: 886px !important;
}
.mpart1{
   display: grid;
  grid-template-columns: 232px 1fr 384px;
  grid-auto-rows: minmax(472, auto);
   background: #fbfbfb;  
}
.mpart1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.mpart1-1Title{
    display: flex;
    justify-content: left;
    margin-top: 96px;
    margin-bottom: 2rem;
}
.mpart1Title{
height: 88px;
font-family: Inter;
font-style: normal;
font-weight: bold;
font-size: 64px;
line-height: 88px;
/* identical to box height, or 137% */
margin-left: 64px;
letter-spacing: 0.015em;
text-transform: uppercase;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart1p{
    height: 80px;
    margin-top: 0px;
    margin-bottom: 92px !important;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 500;
font-size: 20px !important;
line-height: 40px;
/* or 167% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart13-1Line{
  display: none;
}
 .mpart8Line {
  width: 120px;
  height: 1px;
  margin-left: 170px;
  margin-top: 108px;
  margin-bottom: 99px;
  background: #b4c0cf;
}
.mpart8Margin {
  margin-bottom: 40px;
  margin-top: 40px;
}
.mpart8Title {
  width: 80%;
  height: 96px;
  margin-bottom: 104px;
  margin-left: 170px;
  margin-right: 32px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.mpart2
{
    display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-0 {
  grid-column: 1/2;
  grid-row: 3/3;
  margin-top: 8rem !important;
}
.mpart2-1 {
  grid-column: 2/4;
  grid-row: 1/2;
  text-align: left;
}
.mpart2-2 {
  grid-column: 5/7;
  grid-row: 1/2;
}
.mpart2-3 {
  grid-column: 2/4;
  grid-row: 2/3;
  margin-top: 32px;
}
.mpart2-4 {
  grid-column: 5/7;
  grid-row: 2/3;
  text-align: left;
  margin-top: 32px;
}
.mpart2-5 {
  grid-column: 2/4;
  grid-row: 3/3;

}
.mpart2-6 {
  grid-column: 5/7;
  grid-row: 3/3;
}
.mpart2-7 {
  grid-column: 2/4;
  grid-row: 4/4;
  margin-top: 32px;
}
.mpart2-8 {
  grid-column: 5/7;
  grid-row: 4/4;
  text-align: left;
  margin-top: 32px;
}
.mpart2-9 {
  grid-column: 4/8;
  grid-row: 5/5;

}
.mpart2-1Line{
    width: 760px;
height: 1px;
margin-top: 64px;
/* line (darck) */
margin-bottom: 39px;
background: #B4C0CF;
}
.mpart2-1p{
    width: 696px;
    height: 120px;
text-align: left;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 40px;
/* or 222% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart5leftLine {
  width: 164px;
  height: 2px;
  margin-top: 180px;
  margin-left: 18px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart5left {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

/************part8  ****************/

.mpart8 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 0.5fr 0.5fr;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.mpart8-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart8-1 {
  grid-column: 1/2;
  grid-row: 3/4;
  display: block;
}

.mpart8-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}

.mpart8-3 {
  grid-column: 4/5;
  grid-row: 2/2;
}

.mpart8-4 {
  grid-column: 5/6;
  grid-row: 2/2;
}

.mpart8-5 {
  grid-column: 2/6;
  grid-row: 3/4;
}
.mpart8InfoLine {
  width: 164px;
  height: 2px;
  right: -151px;
  bottom: -2px;

  /* metalix (ligtt,text) */

  background: #36454f;
  transform: rotate(-90deg);
}
.mpartInfoT {
  width: 170px;
  height: 24px;

  margin-top: 150px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}
#part8carousel .VueCarousel-navigation-next{
    
    z-index: 4 !important;
    margin-right: 135px !important;
    margin-top: -530px !important;
}
#part8carousel .VueCarousel-navigation-prev{
   
    margin-top: -530px !important;
    margin-left: 1365px !important;
    z-index: 4 !important;
}
/***********part 8 end */
/**************part12 */

.mpart12 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart12-1 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.mpart12-2 {
  grid-column: 1/2;
  grid-row: 1/7;
}
.mpart12-3 {
  grid-column: 2/4;
  grid-row: 2/3;
}
.mpart12-4 {
  grid-column: 5/5;
  grid-row: 2/5;
}
.mpart12-5 {
  grid-column: 2/4;
  grid-row: 3/4;
}
.mpart12-6 {
  grid-column: 2/4;
  grid-row: 4/6;
}
.mpart12TitleLine {
  width: 392px;
  height: 4px;
  margin-top: 96px;
  margin-bottom: 76px;
  /* _Light */

  background: #fbfbfb;
}
.mpart12Tp {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Tp2 {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-top: 72px;
  margin-bottom: 104px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12-0Line {
  width: 120px;
  height: 2px;
  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */
  margin-left: 0px;
  background: #fbfbfb;
}
.mpart12-1Line {
  width: 840px;
  height: 2px;

  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12-2Info {
  margin-top: 300px;
  width: 247px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* line (darck) */

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.fishes
    {
      position: relative;
      top: 0;
      right: 0;
      /* width: 100%; */
    }
    .fish
    {
      position: absolute;
    top: 56px;
    right: -5rem;
    width: 144px;
    height: 144px;
    }
.mpart12-2InfoLine {
  width: 164px;
  height: 2px;
  margin-top: 190px;
  margin-left: 43px;
  background: #4b5a64;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart12-3T {
  width: 543px;
  height: 144px;
  margin-top: 0;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Checkp {
  width: 310px;
  height: 48px;
  text-align: left;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  margin-left: 50px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
#mpart12Check {
  width: 32px;
  height: 32px;
  background-color: #36454f !important;
  /* Light (darck) 02 */

  border: 1px solid #9dafbc;
  box-sizing: border-box;
  border-radius: 1.5px;
}
.mpart12InfoBT {
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;

  /* Metalix_darck */

  color: #272a2e;
}
.mpart12InfoLine {
  width: 840px;
  height: 1px;
  margin-bottom: 63px;
  /* _Light */
margin-left: 13px;
margin-top: 4rem;
  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12InfoMust {
  width: 532px;
  height: 24px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  margin-top: 40px;
  margin-bottom: 104px;
  margin-left: 15px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12InfoButton {
  width: 392px;
  height: 80px;

  background: #cfd3d6;
  box-shadow: 0px 4px 32px #575d65;
}

.mpart12Infotextarea {
  background: #fbfbfb;
margin-top: 48px;
  margin-left: -10px !important;
  width: 830px !important;
height: 80px;
border: 1px solid #fbfbfb;
box-sizing: border-box;
resize: none;
}
#fname {
  width: 392px;
  height: 64px;

  /* _Light */

  background: #fbfbfb;
  /* _Light */

  border: 1px solid #fbfbfb;
  box-sizing: border-box;
}
/****************part12 end*/
/*****part 13 */
.mpart13 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.mpart13-1 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart13-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}
.mpart13-3 {
  grid-column: 5/7;
  grid-row: 2/3;
}
.mpart13-4 {
  grid-column: 2/4;
  grid-row: 3/3;
}
.mpart13-5 {
  grid-column: 4/8;
  grid-row: 3/3;
}
.mpart13-4Line {
  width: 392px;
  height: 4px;

  /* _Text */

  background: #233b57;
}
.mpart13icon {
  margin-top: -15px;
}
.mpart13-4Address {
  width: 336px;
  height: 48px;
  margin-top: 35px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4PhoneUl2 {
  width: 336px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-left: 28px;
  list-style-type: none;
  letter-spacing: 0.15em;
  margin-bottom: 105px;
  margin-top: 88px;
  /* active(bottom) */

  color: #d19258;
}
.mpart13-4mailp2 {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  margin-left: 28px;
  /* margin-top: 15px; */
  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4mailp {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  letter-spacing: 0.15em;
  margin-left: 30px;
  /* Text */

  margin-top: 14px;
  color: #233b57;
}
.mpart13-4PhoneUl {
  width: 336px;
  height: 72px;
  margin-top: 60px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-0T {
  width: 89px;
  height: 24px;
  margin-top: 15px;
  margin-left: 36px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */

  color: #233b57;

  transform: rotate(-90deg);
}
.mpart13-0L {
  width: 164px;
  height: 2px;
  margin-top: 150px;
  /* margin-bottom: 400px; */
  /* _Text */

  background: #233b57;
  transform: rotate(-90deg);
}
.mpart13-1Line {
  width: 120px;
  height: 1px;
  margin-top: 108px;
  margin-bottom: 99px;

  background: #b4c0cf;
}
.mpart13T {
  width: 715px;
  height: 96px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  margin-top: 35px;
  margin-bottom: 96px;
  /* Text */

  text-align: left;
  color: #233b57;
}
.mpart13Tp {
  width: 696px;
  height: 80px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */
  margin-top: 35px;
  letter-spacing: 0.1em;
  text-indent: 32px;
  margin-top: 15rem;
  /* Text */

  color: #233b57;
}
/***********part 13 end */
/******part 14 *****/
.part14 {
  display: grid;
  grid-template-columns: 200px 1fr 0.5fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.part14-1 {
  grid-column: 2/3;
  grid-row: 2/2;
  display: flex;

}
.part14-2 {
  grid-column: 4/5;
  grid-row: 2/2;
    display: flex;
}
.part14-3 {
  grid-column: 2/3;
  grid-row: 3/3;
    display: flex;
}
.part14-4 {
  grid-column: 4/5;
  grid-row: 3/3;
    display: flex;
}
.part14-5 {
  grid-column: 2/3;
  grid-row: 4/4;
    display: flex;
}

.part14-6 {
  grid-column: 4/5;
  grid-row: 4/4;
    display: flex;
}
.part14-8 {
  grid-column: 2/5;
  grid-row: 1/2;
}
.part14Line{
width: 1672px;
height: 1px;
left: 200px;
top: 3600px;
margin-bottom:127px ;
margin-top: 96px;
/* line (darck) */

background: #B4C0CF;
}
.part14h1{
width: 100%;
height: 32px;
left: 176px;
top: 8px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 32px;
/* identical to box height, or 133% */

letter-spacing: 0.1em;

/* metalix (ligtt,text) */

color: #36454F;
}
.part14p{
  margin-top: 40px;
  margin-bottom: 112px;
  width: 544px;
height: 96px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 32px;
/* or 200% */

letter-spacing: 0.1em;
text-indent: 24px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart5leftLine-1 {
  width: 172px;
  height: 2px;
  margin-top: 180px;
  margin-left: 0px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
/******part 14 end */
/****part15 */
.part15 {
  display: grid;
  grid-template-columns: 200px 1fr ;
  grid-auto-rows: minmax(1136, auto);
  background: #F2F6F5;
}
.part15-0{
  grid-column: 1/2;
  grid-row: 1/2;
}

.part15-1{
  grid-column: 2/3;
  grid-row: 1/2;
}
.part15Line{
  width: 384px;
height: 2px;
margin-top: 287px;
    margin-left: -95px;

/* metalix (ligtt,text) */

background: #36454F;
/* line */

box-shadow: inset 1px 0px 0px #36454F;
transform: rotate(-90deg);
}
.part15h1{
  text-align: left;
  margin-top: 144px;
  margin-bottom: 112px;
  margin-left: 150px;
  width: 1152px;
height: 224px;
left: 384px;
top: 4704px;

font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 56px;
/* or 175% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
/****part15 end*/

/* Smartphones (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 320px) 
and (max-device-width : 480px) {
/* Styles */
 .sending-btn{
    width: 340px !important;
    margin-left: 28px !important;
}
.form-metalix-1{
  width: 340px !important;
  margin-left: 17px;
}
.checking{
  display: none;
}
.mpart13-4 .bus_footer{
  margin-top: 0 !important;
  margin-left: 3px;
}
.mpart13-2 .row{
  width: 80%;
}
.part14-4{
  margin-top: 2rem;
}
.part14-5{
  margin-top: 0 !important;
}
.part14-1 img, .part14-2 img, .part14-3 img, .part14-4 img, .part14-5 img, .part14-6 img{
  width: 70px;
  height: 70px;
  margin-left: 2rem;
}
.part14-1{
  margin-bottom: 3rem;
}
.part14-5{
  margin-top: 7rem !important;
}
.part14-3 h1{
  margin-bottom: 3rem;
}
.part14-3{
  margin-bottom: 11rem;
  margin-top: 4rem;
}
.part14-1 h1{
  margin-bottom: 3rem;
}
.mpart2-1 .mpart2-1p{
  padding-top: 13rem;
  line-height: 40px;
  width: 95% !important;
}
.four-inner{
  display: none !important;
}
.mpart2-4 .bus_text-1{
  line-height: 40px;
  width: 95%;
  margin-top: -8rem !important;
}
.mpart2-5 .mpart2-1p{
  line-height: 40px;
  width: 95% !important;
  margin-top: -10rem;
}
.mpart12 {
    display: grid;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .mpart12-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .mpart12-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }
  .mpart12-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
    display: flex !important;
  }
  .mpart12-3 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .mpart12-4 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .mpart12-5 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
  }
  .mpart12-6 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
.mpart12{
  margin-top: 0 !important;
  grid-template-columns: 25px 1fr 1fr 1fr 1fr 1fr !important;
}
.mpart12-4{
  margin-top: 8rem;
}
.mpart12-1Line {
    width: 412px !important;
    height: 2px;
    margin-top: 0px !important;
    margin-bottom: 39px !important;
    background: #fbfbfb;
    opacity: 0.16;
}
.mpart12InfoMust {
    width: 380px !important;
    height: 24px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 40px !important;
    margin-bottom: 70px !important;
    margin-left: 25px !important;
    letter-spacing: 0.1em;
    color: #fbfbfb;
}
.mpart12InfoButton {
    width: 360px !important;
    height: 80px ;
    background: #cfd3d6;
    box-shadow: 0px 4px 32px #575d65;
   
    margin-top: 140px;
}
#mpart12Check{
  margin-left: 20px !important;
}

.mpart12-3T{
  margin-left: 25px;
}
.mpart12-0Line {
    
    margin-top: 70px !important;
    margin-bottom: 70px !important;
   
}
.mpart13T {
    width: 380px !important;
    font-size: 20px !important;
   margin-left: 25px;
   line-height: 40px !important;
   padding-top: 40px;
}
.mpart12Tp, .mpart12Tp2 {
    width: 380px !important;
    margin-left: 25px;
}
.mpart13{
  display: block !important;
}
.mpart13-4{
  margin-left: 25px;
}
.mpart13-4Line, .part14Line, .mpart2-1Line{
  display: none;
}
.mpart13Tp{
  margin-left: 25px;
  width: 350px !important;
  margin-top: 7rem;
}
.mpart13-4PhoneUl{
  margin-top: 20px !important;
}
.mpart13-0{
  display: none;
}
.mpart13-4PhoneUl2{
  margin-left: 28px;
  margin-bottom: 45px !important;
  margin-top: 28px !important;
}
.mpart12TitleLine{
  width: 300px;
}
.mpart12Infotextarea{
  width: 360px !important;
  margin-left: 25px !important;
}
.part14{
  padding-top: 50px;
}
.mpart2-3{
  margin-top: 0px !important;
}
#fname{
  width: 360px !important;
  margin-left: 25px !important;
}
.part3[data-v-8dc7cce2] {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(80px, auto);
}
.decorative-underfooter{
  margin-top: 20px !important;
}
.mpart12-3T {
    width: 300px !important;
    height: 120px !important;
    margin-top: 0;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px !important;
    line-height: 48px;
    letter-spacing: 0.1em;
    color: #fbfbfb;
}
.mpart1{
  grid-template-columns: 25px 1fr 384px !important;
}
.mpart12-2Info, .mpart12-2InfoLine{
  display: none;
}
.part14Line{
  width: 400px !important;
}
.part14{
  grid-template-columns: 25px 1fr 0.5fr 1fr 0.5fr !important;
  display: block !important;
}
.part14-0{
  display: none;
}
.part14p {
    margin-top: 20px !important;
    margin-bottom: 112px;
    width: 220px !important;
    height: 106px !important;
    left: 176px;
    top: 80px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0.1em;
    text-indent: 24px;
    color: #36454F;
}
.miniImgClass {
    width: 80px !important;
    height: 80px !important;
    margin-right: 30px !important;
    margin-left: 25px !important;
}
.part14h1 {
    width: 220px !important;
    height: 42px !important;
    left: 156px !important;
    top: 8px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 18px !important;
    line-height: 32px !important;
    letter-spacing: 0.1em;
    color: #36454F;
}
.mpart1-1Title .decorative-image-main{
  height: 70px !important;
  width: 70px !important;
}
.bus-text{
  margin-left: 24px !important;
}
.mpart2-1 .mpart2-1p{
  height: 200px !important;
}
.mpart2-1Line{
  width: 100% !important;
}
.mpart1Title {
    height: 88px;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 24px !important;
    line-height: 40px !important;
    margin-left: 30px !important;
    letter-spacing: 0.015em;
    text-transform: uppercase;
    color: #36454F;
}
.mpart2-1 .bus_text{
  height: 450px !important;
}
.mpart2{
  display: block !important;
}
.mpart2-4 .mpart2-1p{
  line-height: 40px;
  width: 95% !important;
}
.fish{
  margin-right: 12rem;
  margin-top: 2.5rem;
}
.mpart2-2{
  margin-top: 10rem;
}
.mpart2-6{
  margin-top: 11rem;
}
.part14-1{
  margin-top: 0 !important;
}
.decorative-image-2{
  width: 100%;
  height: auto;
}

.mpart2-1p {
    width: 396px !important;
    height: 500px !important;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0.1em;
    text-indent: 32px;
    color: #36454F;
    padding-left: 2rem;
}
.mpart2-0{
  display: none;
}
.decorative-section-text{
  height: 330px !important;
}
.part15-0{
  display: none;
}
.part15{
  grid-template-columns: 30px 1fr;
}
.part15h1{
  margin-left: 0;
  width: 95%;
  font-size: 20px;
  margin-top: 2rem;
}
.mpart8Title{
  margin-left: 30px;
 font-size: 20px;
 margin-bottom: 17rem;
}
.mpart8HideInfo{
  display: none;
}
.mpart8Line{
  margin-left: 30px;
  margin-bottom: 80px;
}
.carouselMain{
  display: block;
  padding: 4vh 5vw;
}
.home-icon{
  margin-left: -5rem;
}
.part8mainTitle{
  font-size: 22px;
  line-height: 40px;
  margin-top: 1rem;
}
.part8mainTitlep{
  width: 90%;
  font-size: 18px;
}
.mpart12Infotextarea{
  width: 300px !important;
  margin-left: 32px !important;
}
.metalstair-text-footer{
  margin-top: 0px !important;
}
.mpart12 {
    display: grid;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .mpart12-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .mpart12-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }
  .mpart12-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
    display: flex !important;
  }
  .mpart12-3 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .mpart12-4 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .mpart12-5 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
  }
  .mpart12-6 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
.mpart12{
  margin-top: 0 !important;
  grid-template-columns: 25px 1fr 1fr 1fr 1fr 1fr !important;
}
.mpart12-4{
  margin-top: 5rem;
}
.mpart12-1Line {
    width: 300px !important;
    height: 2px;
    margin-top: 0px !important;
    margin-bottom: 39px !important;
    background: #fbfbfb;
    opacity: 0.16;
}
.mpart12InfoMust {
    width: 380px !important;
    height: 24px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 40px !important;
    margin-bottom: 70px !important;
    margin-left: 25px !important;
    letter-spacing: 0.1em;
    color: #fbfbfb;
}
.mpart12InfoButton {
    width: 300px !important;
    height: 80px ;
    background: #cfd3d6;
    box-shadow: 0px 4px 32px #575d65;
    margin-left: 32px;
    margin-top: 40px;
}
#mpart12Check{
  margin-left: 20px !important;
}

.mpart12-3T{
  margin-left: 25px;
}
.inputMar{
  margin-left: 0;
}
#fname{
  width: 300px !important;
  margin-left: 35px !important;

}

.mpart12-0Line {
    
    margin-top: 70px !important;
    margin-bottom: 70px !important;
   
}
.mpart13T {
    width: 300px !important;
    font-size: 20px !important;
   margin-left: 25px;
   line-height: 40px !important;
   padding-top: 0px;
}
.mpart12Tp, .mpart12Tp2 {
    width: 300px !important;
    margin-left: 25px;
}
.mpart12InfoLine{
  display: none;
}
.mt-3 {
    margin-top: 3rem !important;
}
.mt-5 {
    margin-top: 0rem !important;
}
.mpart13-4PhoneUl2{
  width: 90%;
}
}

/* Smartphones (landscape) ----------- */
@media only screen 
and (min-width : 321px) {
/* Styles */
}

/* Smartphones (portrait) ----------- */
@media only screen 
and (max-width : 320px) {
/* Styles */
}

/* iPads (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) {
/* Styles */
}

/* iPads (landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : landscape) {
/* Styles */
}

/* iPads (portrait) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait) {
/* Styles */
 .part12Infotextarea{
    width: 600px !important;
  }
}

/* Desktops and laptops ----------- */
@media only screen 
and (max-width : 1224px) {
/* Styles */

}
/* Desktops and laptops  1280----------- */
@media (min-width: 1025px)
and (max-width : 1280px) {
/* Styles */
.part14h1{
  width: 100%;
}
.mpart12InfoButton{
  width: 300px !important;
}
.miniImgClass{
  width: 48px;
  height: 48px;
  margin-right: 28px;
}
.mpart1Title{
  font-size: 36px !important;
}
.mpart12InfoMust{
  margin-left: 76px !important;
}
.mpart12InfoLine{
  width: 805px;
  margin-left: 4.2rem;
}
.four-inner{
  width: 38.7%;
}
 .four-section{
   padding-left: 4.7rem;
  margin-bottom: 60px;
 }

/****part2 */
.mpart2
{
    display: grid;
  grid-template-columns: 36px 1fr 1fr 1fr 1fr 1fr 0.5fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-3 img{
  width: 80%;
  height: auto;
}
.mpart2-2 img{
  width: 80%;
  height: auto;
}
.mpart2-6 img{
  width: 80%;
  height: auto;
}
.mpart2-7 img{
  width: 80%;
  height: auto;
}
.mpart2-1Line{
  width: 360px !important;
}
.mpart2-1p{
  width: 100% !important;
  font-size: 12px !important;
}
/***part14 */
.part14 {
  display: grid;
  grid-template-columns: 36px 1fr 0.5fr 1fr 0.5fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14-0{
  display: none;
}
.part14p{
  width: 360px !important;
}
.part14Line{
  width: 80% !important;
}
.mpart2-0{
  display: none;
}
/****part15 */
.part15h1{
  font-size: 22px !important;
  width: 740px !important;
  margin-left: 10px !important;
}
/****part8 */
.mpart8 {
  display: grid;
  grid-template-columns: 16px 2fr 0.5fr 0.5fr 0.5fr !important;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.mpart8-1{
  display: none !important;
}
.mpart8Title{
  font-size: 22px !important;
}
/*****part12 */
/****part12 */
.mpart12 {
    display: grid;
    grid-template-columns: 36px 1fr 1fr 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .mpart12-2 {
    display: none !important;
  }
  .mpart12-2{
  display: none !important;
}
.mpart12-0 {
  grid-column: 2/4 !important;
  grid-row: 1/2 !important;
}
.mpart12-1 {
  grid-column: 3/3 !important;
  grid-row: 1/2 !important;
}

.mpart12-3 {
  grid-column: 2/3 !important;
  grid-row: 2/3 !important;
}
.mpart12-4 {
  grid-column: 3/4 !important;
  grid-row: 2/5 !important;
}
.mpart12-5 {
  grid-column: 2/3 !important;
  grid-row: 3/4 !important;
}
.mpart12-6 {
  grid-column: 2/3 !important;
  grid-row: 4/5 !important;
}
.inputMar{
  margin-left: 76px !important;
}
  .mpart12-3T {
    width: 303px !important;
    height: 144px;
    margin-top: 0;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 18px !important;
  }
  #fname {
    width: 300px !important;
    height: 64px;

    /* _Light */

    background: #fbfbfb;
    /* _Light */

    border: 1px solid #fbfbfb;
    box-sizing: border-box;
  }
  
  .mpart12Infotextarea {
    width: 690px !important;
  margin-left: -80px !important;
  }
  .mpart12TitleLine {
    display: none !important;
  }
  .mpart12Margin{
    margin-left: 95px;
  }
  .mpart12Tp{
    max-width: 328px;
  }
  .mpart12Tp2{
    max-width:328px
  }
/****part13 */
.mpart13 {
  display: grid;
  grid-template-columns: 36px 1fr 1fr 1fr 1fr 1fr 0.5fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13T{
  font-size: 16px !important;
}
.mpart13Tp{
    width: 520px !important;
    font-size: 14px !important;
}
.mpart13-0 {
  display: none !important;
}
/******part14 */
.part14p{
  font-size: 12px !important;
}
}
@media (min-width: 1281px)
and (max-width : 1440px) {
.mpart1Title{
  font-size: 36px !important;
}
.mpart12InfoButton{
  width: 372px;
}
.mpart13-0L{
  margin-left: -2px;
}
.mpart1{

    grid-template-columns: 170px 1fr 384px;






}

.fish{
  margin-top: -35px;
  width: 120px !important;
  height: 120px !important;
}
.mpart1-1Title{
  margin-bottom: 2rem;
}
/****part2 */
.mpart2
{
    display: grid;
  grid-template-columns: 36px 1fr 1fr 1fr 1fr 1fr 0.5fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-3 img{
  width: 565px;
  height: auto;
}
.mpart2-2 img{
   width: 565px;
  height: auto;
}
.mpart2-6 img{
   width: 565px;
  height: auto;
}
.mpart2-7 img{
  width: 80%;
  height: auto;
}
.mpart2-1Line{
  width: 360px !important;
  margin-top: 0;
}
.mpart2-1p{
  width: 100% !important;
  font-size: 18px !important;
  margin-top: 3rem;
}
.mpart5leftLine{
  margin-left: 3px;
}
.mpart2-0{
  grid-row: 1/1;
}
/***part14 */
.part14 {
  display: grid;
  grid-template-columns: 36px 1fr 0.5fr 1fr 0.5fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14 {
    grid-template-columns: 170px 1fr 0.5fr 1fr 0.5fr !important;
}

.part14p{
  width: 360px !important;
}
.part14Line{
  width: 80% !important;
}
/****part15 */
.part15h1{
  font-size: 22px !important;
  width: 740px !important;
  margin-left: 8rem;
}
/****part8 */
.mpart8 {
  display: grid;
  grid-template-columns: 16px 2fr 0.5fr 0.5fr 0.5fr !important;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.mpart2{
    grid-template-columns: 170px 1fr 1fr 1fr 1fr 1fr 0.5fr !important;
    padding-top: 6rem;
}
.mpart8Line{
  margin-left: 160px;
}
.mpart8-1{
  display: none !important;
}
.mpart8Title{
  font-size: 22px !important;
  margin-left: 160px;
}
.mpart12-0Line{
  margin-left: 40px;
}
.mpart12-3T{
  font-size: 26px;
}
.carouselMain{
  padding: 15vh 2.5vw;
}
.part8mainTitle{
  font-size: 30px;
}
/*****part12 */
/****part12 */
.mpart12 {
  display: grid;
  grid-template-columns: 36px 1fr  1fr  1fr 16px !important;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-2{
  display: none !important;
}
.mpart12-0 {
  grid-column: 2/4 !important;
  grid-row: 1/2 !important;
}
.mpart12-1 {
  grid-column: 3/3 !important;
  grid-row: 1/2 !important;
}

.mpart12-3 {
  grid-column: 2/3 !important;
  grid-row: 2/3 !important;
}
.mpart12-4 {
  grid-column: 3/4 !important;
  grid-row: 2/5 !important;
}
.mpart12-5 {
  grid-column: 2/4 !important;
  grid-row: 3/4 !important;
}
.mpart12-6 {
  grid-column: 2/4 !important;
  grid-row: 4/5 !important;
}
.inputMar{
  margin-left: 140px !important;
}

.mpart12-1Line{
  width: 780px !important;
}
#fname {
    width: 372px !important;}

.mpart12InfoLine{
  width: 780px !important;
  margin-left: .8rem;
}
/****part13 */
.mpart13 {
  display: grid;
  grid-template-columns: 170px 1fr 1fr 1fr 1fr 1fr 0.5fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13T{
  font-size: 26px !important;
}
.mpart13Tp{
    width: 520px !important;
    font-size: 14px !important;
}


}
/* Large screens ----------- */
@media only screen 
and (min-width : 1824px) {
/* Styles */
}

/* iPhone 4 ----------- */
@media
only screen and (-webkit-min-device-pixel-ratio : 1.5),
only screen and (min-device-pixel-ratio : 1.5) {
/* Styles */
}
/* ----------- Retina Screens ----------- */
@media screen 
  and (min-device-width: 1200px) 
  and (max-device-width: 1600px) {
   
  }
    @media (min-width: 1367px) and (max-width: 1440px){
.mpart12Infotextarea {
    background: white;
    margin-top: 48px;
    margin-left: 0px !important;
    margin-bottom: 46px;
    width: 780px !important;
    height: 80px;
    border: 1px solid #fbfbfb;
    box-sizing: border-box;
    resize: none;
}
.sending-btn{
  width: 370px;
}
}
</style>